<template>
    <div class="wrap-document">
        <div class="page" v-for="(platform, i) in dataPrint.platform" :key="i">
            <p class="title">
                PERNYATAAN TELAH MELAKUKAN SIMULASI PERDAGANGAN KOMODITI BERJANGKA
                <span v-if="platform.name">{{ "(" + platform.name + ")" }}</span>
                <span v-else>
                    <span v-show="platform.platform == 'BEI05001'">( Jafets Now )</span>
                    <span v-show="platform.platform == 'BEI05002'">( Meta Trader 5 )</span>
                </span>
            </p>
            <div class="content">
                <p>Yang mengisi formulir dibawah ini:</p>
                <tr>
                    <td><label>Nama Lengkap</label></td>
                    <td>:</td>
                    <td class="format-text">
                        {{ dataPrint.fullname ? dataPrint.fullname : "............................." }}
                    </td>
                </tr>
                <tr>
                    <td><label>Tempat/Tanggal Lahir</label></td>
                    <td>:</td>
                    <td class="format-text">
                        {{ dataPrint.tempat_lahir ? dataPrint.tempat_lahir : "............................." }},
                        {{ dataPrint.tanggalLahir | formatDate }}
                    </td>
                </tr>
                <tr>
                    <td><label>Alamat Rumah</label></td>
                    <td>:</td>
                    <td class="format-text">
                        {{ dataPrint.alamat ? dataPrint.alamat : "............................." }}
                    </td>
                </tr>
                <tr>
                    <td><label>No Identitas (KTP/SIM/Passpor)</label></td>
                    <td>:</td>
                    <td class="format-text">
                        {{ dataPrint.ktp ? dataPrint.ktp : "............................." }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>
                            No. Demo Acc
                            <!-- <span v-if="platform.name">{{ platform.name }}</span>
              <span v-else>
                <span v-show="platform.platform == 'BEI05001'">Jafets Now</span>
                <span v-show="platform.platform == 'BEI05002'">GOFX</span>
              </span> -->
                        </label>
                    </td>
                    <td>:</td>
                    <td class="format-text">
                        {{ platform.demo_username ? platform.demo_username : platform.username }}
                    </td>
                </tr>
            </div>

            <div class="content">
                Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah melakukan simulasi bertransaksi di bidang Perdagangan Berjangka Komoditi
                pada PT.ABI Komoditi Berjangka, dan telah memahami tentang tata cara bertransaksi di bidang Perdagangan Berjangka Komoditi.
                <form>
                    <div class="form-group"></div>
                </form>
            </div>
            <div class="content">
                Demikian Pernyataan ini dibuat dengan sebenarnya dalam keadaan sadar, sehat jasmani dan rohani serta tanpa paksaan apapun dari pihak manapun
                <form>
                    <div class="form-group"></div>
                </form>
            </div>

            <div class="persetujuan">
                <div class="ttd">
                    <p>Pernyataan menerima</p>
                    <div class="pernyataan">
                        <input type="radio" name="confirmSimulation" :value="true" v-model="inputStatement" required @change="handleValue" />
                        <label>Ya</label>
                        <input type="radio" :value="false" v-model="inputStatement" @change="handleValue" />
                        <label>Tidak</label>
                    </div>
                </div>
                <div class="ttd">
                    <p>Menerima pada Tanggal</p>
                    <div>
                        {{ currentDate | formatDateTime }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fullName: String,
        dataPrint: Object,
        statementSimulation: Boolean,
    },
    data() {
        return {
            currentDate: "",
            statementInput: "",
        };
    },
    mounted() {
        this.statementInput = this.dataPrint.statement;
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
    computed: {
        inputStatement() {
            return this.statementSimulation;
        },
    },
    methods: {
        handleValue(e) {
            this.$emit("updateValue", e.target._value);
        },
    },
};
</script>

<style scoped>
label {
    width: 8rem;
}

.format-text {
    text-transform: capitalize;
    padding: 0px 0.5rem;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.wrap-document {
    padding-inline: 1cm;
    /* width: 210mm; */
    height: 276.5mm;
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px red solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

/* .wrap-document {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
} */

.tanda-tangan {
    width: 80%;
    text-align: center;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    font-size: 14px;
    margin-bottom: 2rem;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

label {
    margin-right: 15px;
}

.persetujuan {
    width: 60%;
    font-size: 12px;
    margin: 30px auto 90px;
}

.persetujuan .ttd {
    display: flex;
    gap: 1rem;
}

.persetujuan .ttd p {
    width: 10rem;
}

.pernyataan input {
    margin-right: 0.6rem;
}

.pernyataan label {
    width: 2rem;
}
td label {
    text-align: left;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .title {
        margin: 20px auto !important;
    }

    .page {
        padding: 0;
    }

    .persetujuan{
        width: 100%;
    }

    .persetujuan .ttd p{
        width: 9rem;
    }

    label{
        margin-right: unset;
    }
}
</style>
